module.exports = __webpack_public_path__ + "img/2.5c8b5374.png";